export enum ModalResolveType {
  /** 確認 */
  OK = 'ok',
  /** 取消 */
  CANCEL = 'cancel',
  /** 關閉 */
  CLOSED = 'closed',
  /** 由系統層強制關閉彈窗 */
  SYSTEM_CLOSE = 'system_close',
  /** 錯誤 */
  ERROR = 'error',
  /** 客製狀態, 此種狀態下通常會使用 result.data 中的值進行條件判斷 */
  CUSTOM = 'custom',
}

export interface ModalResolveResult<TData, TError> {
  type: ModalResolveType;
  data?: TData;
  error?: TError;
}
